import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MyLocationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"my_location"}/>
}
